import React from 'react';
import { Flex, xcss, Box } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { useIntl } from '@atlassian/jira-intl';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { useIntersectionObserver } from '@atlassian/jira-intersection-observer/src/index.tsx';
import { LeftFooterButton } from '../../../../common/ui/left-footer-button/index.tsx';
import messages from './messages.tsx';

type Props = {
	onShowMore: () => void;
	isPaginationLoading?: boolean;
};

const ShowMoreButton = ({ onShowMore }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<LeftFooterButton
			message={formatMessage(messages.showMoreButtonText)}
			onClick={onShowMore}
			appearance="link"
			testId="jql-builder-basic-picker.ui.async-select.menu-list.show-more-button"
			hasTooltip={false}
			label={formatMessage(messages.showMoreButtonLabel)}
		/>
	);
};

const LoadMoreTrigger = ({ onShowMore, isPaginationLoading }: Props) => {
	const { formatMessage } = useIntl();

	const loadMoreRef = useIntersectionObserver({
		margin: 10,
		onIntersection: () => !isPaginationLoading && onShowMore(),
	});
	return (
		<Box role="option" aria-hidden="true" aria-selected={false}>
			<Flex
				xcss={loadingContainerStyles}
				justifyContent="center"
				alignItems="center"
				ref={loadMoreRef}
			>
				<Spinner label={formatMessage(messages.loadingLabel)} />
			</Flex>
		</Box>
	);
};
const loadingContainerStyles = xcss({
	height: '56px',
});

export default componentWithFG('jql_basic_picker_infinite_scroll', LoadMoreTrigger, ShowMoreButton);
